export enum PlanRecommendationContext {
  AEP_WIZARD = 'AEP_WIZARD',
  WIZARD = 'WIZARD',
  AEP_INITIAL_RECOMMENDATION_EMAIL = 'AEP_INITIAL_RECOMMENDATION_EMAIL',
  MEDIGAP_ANNIVERSARY_BIRTHDAY_STATE = 'MEDIGAP_ANNIVERSARY_BIRTHDAY_STATE',
  MA_WIZARD = 'MA_WIZARD',
}
